
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChevronDown, ChevronUp } from "lucide-react";
import { FAQItem } from "@/data/faqData";

interface FAQCategoryProps {
  items: FAQItem[];
  categoryName: string;
  categoryDescription: string;
}

const FAQCategory = ({ items, categoryName, categoryDescription }: FAQCategoryProps) => {
  const [expandedItems, setExpandedItems] = useState<Set<string>>(new Set());

  const toggleItem = (itemId: string) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(itemId)) {
      newExpanded.delete(itemId);
    } else {
      newExpanded.add(itemId);
    }
    setExpandedItems(newExpanded);
  };

  return (
    <div className="mb-8">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-white mb-2">{categoryName}</h2>
        <p className="text-gray-400">{categoryDescription}</p>
      </div>
      
      <div className="space-y-3">
        {items.map((item) => (
          <Card 
            key={item.id} 
            className="bg-white/5 backdrop-blur-md border-white/10 hover:bg-white/10 transition-all duration-300"
          >
            <CardHeader 
              className="cursor-pointer pb-3"
              onClick={() => toggleItem(item.id)}
            >
              <CardTitle className="text-white flex items-center justify-between text-left text-lg">
                <span className="pr-4">{item.question}</span>
                {expandedItems.has(item.id) ? 
                  <ChevronUp className="w-5 h-5 text-blue-400 flex-shrink-0" /> : 
                  <ChevronDown className="w-5 h-5 text-blue-400 flex-shrink-0" />
                }
              </CardTitle>
            </CardHeader>
            {expandedItems.has(item.id) && (
              <CardContent className="pt-0">
                <p className="text-gray-300 leading-relaxed">{item.answer}</p>
              </CardContent>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default FAQCategory;
